﻿import { Output } from "@models/configurators/outputs/output";
import { FileOutput } from "@models/configurators/outputs/file-output";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { ICadDrawingOutput, IOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";
import { Kbo, KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutput(CToken.CadDrawingOutput, eOutputType.cadDrawing)
export class CadDrawingOutput extends FileOutput implements ICadDrawingOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
    }
}
